import React from 'react';
import SellStockSection from './SellStockSection';
import bs2 from '../../assets/img/icons/bs2.svg';
import bs3 from '../../assets/img/icons/bs3.svg';
import bs4 from '../../assets/img/icons/bs4.svg';
import notebookBuyerSm from '../../assets/img/notebook-b-sm.svg';
import notebookBuyerMd from '../../assets/img/notebook-b-md.svg';
import notebookLg from '../../assets/img/notebook-lg.svg';
import text from '../../assets/img/buy-cars-text.svg';
import rectangle from '../../assets/img/rect-road.svg';

const items = [
  {
    image: bs3,
    title: 'Dealer only stock',
    caption:
      'We only sell dealer stock from the dealer network, meaning you don’t need to waste your time scrolling through low-grade vehicles. You can trust our stock is from a reputable source.',
    imageAlt: 'Handshake and car icons',
  },
  {
    image: bs4,
    title: 'Consistent volume',
    caption:
      'We know seasonality in the motor trade has a huge impact, but we’re commited to consistently having a high volume of stock for you to choose from.',
    imageAlt: 'Car and hand icons',
  },
  {
    image: bs2,
    title: 'Flexible funding options',
    caption:
      'We offer flexible funding via NextGear Capital, where you can use their stocking plan to fund your vehicle purchases.',
    imageAlt: 'Pound icon',
  },
];

function BuySection() {
  return (
    <section className="buy-section" id="buy-car">
      <div className="buy-section-inner">
        <div className="buy-section-header">
          <h2 className="buy-section-header__title">
            <span>SOLUTION</span>
            <span> FOR BUYERS</span>
          </h2>
          <img src={text} alt="Buy cars text" className="buy-section-header__text" />
        </div>
        <div className="buy-section-content">
          <p className="buy-section-header__subtitle">
            <span>
              The Stock Vault is your go-to market place to buy used dealer vehicles, with
            </span>
            <span> ease. No faff, no fuss, just good old-fashioned car buying.</span>
          </p>
          <div className="buy-section__features">
            {items.map((item) => (
              <div className="buy-section__feature">
                <div className="buy-section__feature-box">
                  <img
                    className="buy-section__feature-box-icon"
                    src={item.image}
                    alt={item.imageAlt}
                  />
                </div>
                <div className="buy-section__feature-content">
                  <h4 className="buy-section__feature-title">{item.title}</h4>
                  <span className="buy-section__feature-caption">{item.caption}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      <div className="sell-stock-section-wrapper__inner">
        <div className="buy-section__image-wrapper">
          <img
            className="buy-section__image buy-section__image--sm"
            src={notebookBuyerSm}
            alt="Two notebooks which display web app"
          />
          <img
            className="buy-section__image buy-section__image--md"
            src={notebookBuyerMd}
            alt="Notebook which display web app"
          />
        </div>
        <SellStockSection
          title={
            <>
              <span>Ready to join</span>
              <span> The Stock</span>
              <span> Vault?</span>
            </>
          }
          subtitle="Unlock the Stock."
        />
      </div>
      <div className="buy-section__image-wrapper">
        <img
          className="buy-section__image buy-section__image--lg"
          src={notebookLg}
          alt="Notebook which display web app"
        />
      </div>
      <img src={rectangle} alt="Rectangle" className="buy-section__image__rect" />
    </section>
  );
}

export default BuySection;
